export default __webpack_public_path__ + "520f76b01fbf4de0a0b5c76c6d90c790.svg";